import {pack} from './pack'
import {unpack} from './unpack'
import type {CorePlugin, SingleComponentPlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'

export const componentTypeSingleComponentPlugin = {
    name: 'ComponentTypePlugin',
    pack,
    unpack
} satisfies SingleComponentPlugin

export const componentTypePlugin: CorePlugin = createPluginFromSingleComponentPlugin(componentTypeSingleComponentPlugin)
